export enum RenewalSetupStepTitle {
  plansPlanYear = 'Plan Year & Plans',
  healthPlans = 'Health Plans',
  copays = 'Copays',
}

export enum RenewalPlanOptionValues {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  REQUESTED = 'REQUESTED',
}

export enum CopaysOptionValues {
  ACTIVE = 'ACTIVE',
  REQUESTED = 'REQUESTED',
  CANCELED = 'CANCELED',
}

export enum RenewalSetupStep {
  PlansPlanYear = 'plansPlanYear',
  HealthPlans = 'healthPlans',
  Copays = 'copays',
  RenewalPopup = 'renewalPopup',
}
